const setSpousePassportNoExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_SPOUSEPASSPORTNOEXPIREDATE',
    data,
    text
  }
}

export default {
  setSpousePassportNoExpireDate,
}
